__turbopack_context__.v({
  "blogArticleCard": "BlogArticleCard-module___AWu7W__blogArticleCard",
  "blogArticleCardInner": "BlogArticleCard-module___AWu7W__blogArticleCardInner",
});
